import { Component } from '../../core/component.js';
import { router } from '../../router.js';
import { eventBus } from '../../events.js';
import { MENU_ITEMS } from './sidebar.js';
import { escapeHtml } from '../../core/utils.js';

const BOTTOM_ITEMS = [
    { path: '/',         label: 'Главная',    icon: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="12" y="3" width="7" height="7" rx="1"/><rect x="3" y="12" width="7" height="7" rx="1"/><rect x="12" y="12" width="7" height="7" rx="1"/></svg>' },
    { path: '/calendar', label: 'Календарь',  icon: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="16" height="15" rx="2"/><line x1="3" y1="9" x2="19" y2="9"/><line x1="7" y1="2" x2="7" y2="6"/><line x1="15" y1="2" x2="15" y2="6"/></svg>' },
    { path: null,        label: 'Запись',      icon: 'plus', isAction: true },
    { path: '/clients',  label: 'Клиенты',    icon: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="8" r="3.5"/><path d="M4 19c0-3.5 3-6 7-6s7 2.5 7 6"/></svg>' },
    { path: null,        label: 'Ещё',        icon: 'more', isMore: true },
];

export class BottomNav extends Component {
    constructor() {
        super();
        this.el.className = 'app-bottom-nav';
        this.el.id = 'bottomNav';
        this.state = { drawerOpen: false };
    }

    template() {
        const currentPath = (window.location.hash.slice(1) || '/').split('?')[0];
        const { drawerOpen } = this.state;

        const items = BOTTOM_ITEMS.map(item => {
            if (item.isAction) {
                return `
                    <button class="bottom-nav-item bottom-nav-action" id="bottomNewAppointment">
                        <span class="bottom-nav-plus">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                            </svg>
                        </span>
                    </button>
                `;
            }

            if (item.isMore) {
                return `
                    <button class="bottom-nav-item ${drawerOpen ? 'active' : ''}" id="bottomMore">
                        <span class="bottom-nav-icon">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5">
                                <circle cx="11" cy="5" r="1.5"/><circle cx="11" cy="11" r="1.5"/><circle cx="11" cy="17" r="1.5"/>
                            </svg>
                        </span>
                        <span class="bottom-nav-label">${item.label}</span>
                    </button>
                `;
            }

            const isActive = item.path === '/'
                ? currentPath === '/'
                : currentPath.startsWith(item.path);

            return `
                <a href="#${item.path}" class="bottom-nav-item ${isActive ? 'active' : ''}">
                    <span class="bottom-nav-icon">${item.icon}</span>
                    <span class="bottom-nav-label">${item.label}</span>
                </a>
            `;
        }).join('');

        const drawerHtml = drawerOpen ? `
            <div class="bottom-drawer-overlay" id="drawerOverlay"></div>
            <div class="bottom-drawer" id="bottomDrawer">
                <div class="bottom-drawer-handle"></div>
                <nav class="bottom-drawer-nav">
                    ${MENU_ITEMS.map(item => {
                        const isActive = item.path === '/'
                            ? currentPath === '/'
                            : currentPath.startsWith(item.path);
                        return `<a href="#${item.path}" class="bottom-drawer-item ${isActive ? 'active' : ''}">
                            <span class="bottom-drawer-icon">${item.icon}</span>
                            <span>${escapeHtml(item.label)}</span>
                        </a>`;
                    }).join('')}
                </nav>
            </div>
        ` : '';

        return `${drawerHtml}${items}`;
    }

    afterRender() {
        const moreBtn = this.el.querySelector('#bottomMore');
        if (moreBtn) {
            moreBtn.addEventListener('click', () => {
                this.setState({ drawerOpen: !this.state.drawerOpen });
            });
        }

        const overlay = this.el.querySelector('#drawerOverlay');
        if (overlay) {
            overlay.addEventListener('click', () => {
                this.setState({ drawerOpen: false });
            });
        }

        const newBtn = this.el.querySelector('#bottomNewAppointment');
        if (newBtn) {
            newBtn.addEventListener('click', () => {
                eventBus.emit('appointment:new');
            });
        }

        // Close drawer on nav
        this.el.querySelectorAll('.bottom-drawer-item').forEach(link => {
            link.addEventListener('click', () => {
                this.setState({ drawerOpen: false });
            });
        });
    }

    mount(container) {
        super.mount(container);
        this._unsubHash = () => this.render();
        window.addEventListener('hashchange', this._unsubHash);
        return this;
    }

    destroy() {
        if (this._unsubHash) window.removeEventListener('hashchange', this._unsubHash);
        super.destroy();
    }
}
